import { getCookieInClientSide } from "@/lib/utils/get-cookies-for-client";
import { getCommonCDByCodes } from "@/services/rest/common-service";
import { useQuery } from "@tanstack/react-query";

export function useCommonCDByCodes(codes: string[]) {
  return useQuery({
    queryKey: [
      "getCommonCDByCodes",
      { codes },
      getCookieInClientSide("NEXT_LOCALE"),
    ],
    queryFn: async () => {
      return await getCommonCDByCodes(codes);
    },
    staleTime: 2000 * 60, // 2m
  });
}
